export default "__VITE_ASSET__B4Bs34Eo__"